import PropTypes from "prop-types";
import { useComponentVisible } from "../../../hooks";
import {
  PRICE_ASC,
  PRICE_DESC,
  DISCOUNT,
  FEATURED
} from "../constants";
import { useFilterSort } from "../hooks/useFilterSort";
import { CloseIcon, CheckIcon } from "@components/Icon";
import styles from "./styles/SortMobile.module.css"

export const SortMobile = ({
  productsFromCollection,
  filteredValues,
  showSort,
  setShowSort,
  sortBy,
  setSortBy
}) => {
  // Hook that alerts clicks outside of the passed ref
  const { ref } = useComponentVisible(() => setShowSort(false));
  const { productList } = useFilterSort({
    products: productsFromCollection,
    filteredValues,
    sortBy
  });

  const findDiscountItems = () => {
    if (productList && productList.length > 0) {
      const discountValues = productList.map(product => product.sortBy.discount);
      const hasDiscount = value => value > 0;
      const listHasDiscountedItem = discountValues.some(hasDiscount);
      return listHasDiscountedItem;
    }
  };

  const listHasDiscount = findDiscountItems();

  const sortValues = [FEATURED, PRICE_ASC, PRICE_DESC, listHasDiscount && DISCOUNT];

  const onChange = value => {
    setSortBy(value);
    setShowSort(false);
  };

  const containerStyles = `
    ${styles.container}
    ${showSort ? styles.showContainer : ''}
  `;

  const Header = () => {
    return (
      <header className={styles.heading}>
        <h4>Sort By:</h4>
        <button
          onClick={() => setShowSort(false)}
          aria-label="close sort menu"
        >
          <CloseIcon />
        </button>
      </header>
    )
  };

  const List = () => {
    return (
      <ul className={styles.list}>
        {sortValues.map((value, index) => (
          <ListItem key={`${value}-${index}`} value={value} />
        ))}
      </ul>
    )
  };

  const ListItem = ({ value }) => {
    return (
      <li className={styles.listItem}>
        <button className={styles.button} onClick={() => onChange(value)}>
          {value}
          {sortBy === value && <CheckIcon />}
        </button>
      </li>
    );
  };

  return (
    <div className={containerStyles} ref={ref}>
      <Header />
      <List />
    </div>
  );
};

SortMobile.propTypes = {
  showSort: PropTypes.bool,
  setShowSort: PropTypes.func,
  sortBy: PropTypes.string,
  setSortBy: PropTypes.func,
  collection: PropTypes.shape({
    collectionDescription: PropTypes.string,
    handle: PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.string,
  }),
};
